import React, { useEffect } from "react";
import "./Announcement.css";
import Announcement_card from "./Announcement_card/Announcement_card";
import Common_white_header from "../Common/Common_Component/Common_white_header/Common_white_header";
import No_data from "../Common/No_data/No_data";
import { useDispatch, useSelector } from "react-redux";
import { AllAnnouncement } from "../../features/admin/common/Slice";
import { formatNotifDate } from "../../utils/common";

function Announcement() {
  const dispatch = useDispatch()
  const announcements = useSelector((state) => state.common.announcements);
  useEffect(() => {
    dispatch(AllAnnouncement());
  }, [dispatch]);
  return (
    <>
      <section className="Announcement">
        <Common_white_header headingText={"Announcement"} />
        <div className="container">
          {announcements?.length > 0 ?
            announcements?.map((data => (

              <Announcement_card name={data?.name} description={data?.description} date={formatNotifDate(data?.createdAt)} />
            )))
            :

            < No_data />
          }
        </div>
      </section>
    </>
  );
}

export default Announcement;
